import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 148 14",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("linearGradient", {
  id: "gradient-arrow_svg__a",
  x1: "0%",
  x2: "100%",
  y1: "50%",
  y2: "50%"
}, [
  /*#__PURE__*/_createElementVNode("stop", {
    offset: "0",
    "stop-color": "#e4d5b7",
    "stop-opacity": "0"
  }),
  /*#__PURE__*/_createElementVNode("stop", {
    offset: "1",
    "stop-color": "#c5ab80"
  })
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  d: "m644 11786 14 7-14 7v-6h-135v-2h135z",
  fill: "url(#gradient-arrow_svg__a)",
  transform: "translate(-510 -11786)"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }